function buildUrlWithQueryParams(
    uri: string = "",
    params: {
        [key: string]: string | number | boolean | Date | null | undefined | (string | number | boolean | Date)[]
    }
): string {
    let urlWithParams: string = uri;
    const queryParams: string[] = [];

    Object.entries(params).forEach(([key, value]) => {
        if ((value !== null && value !== undefined && !!value) || value === 0 || value === false) {
            if (Array.isArray(value)) {
                value.forEach(item => {
                    if (item !== null && item !== undefined) {
                        queryParams.push(`${key}=${encodeURIComponent(item.toString())}`);
                    }
                });
            } else if (value instanceof Date) {
                queryParams.push(`${key}=${encodeURIComponent(value.toISOString())}`);
            } else {
                queryParams.push(`${key}=${encodeURIComponent(value.toString())}`);
            }
        }
    });

    if (queryParams.length > 0) {
        urlWithParams += `?${queryParams.join("&")}`;
    }

    return urlWithParams;
}

export const UrlHelper = {
    buildUrlWithQueryParams,
};
